import React from 'react';

import { flagStyles } from '../settings';

const SvgKZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2952px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKZ;
